import pxToRem from "../Themes/Functions/pxToRem";

const scrollBarStyle = {
  "::-webkit-scrollbar": {
    width: pxToRem(5),
  },
  "::-webkit-scrollbar-track": {
    background: "#f1f1f1",
  },
  "::-webkit-scrollbar-thumb": {
    background: "#C1C1C1",
  },
  "::-webkit-scrollbar-thumb:hover": {
    background: "#ACABAB",
  },
};

const noScrollBarStyle = {
  "::-webkit-scrollbar": {
    display: "none",
  },
};

export { scrollBarStyle, noScrollBarStyle };
